import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { NotificationService } from 'src/app/services/notification.service';
import { decodeSessionData, hideEmailAddress, SessionData } from 'src/app/util/Helper';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-estate',
  templateUrl: './estate.component.html',
  styleUrls: ['./estate.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('300ms', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
  ]
})
export class EstateComponent implements OnInit {
  // Url Params
  session: string = ""; // used to resume session
  @ViewChild('scroller', { static: false }) scroller?: ElementRef;

  MileleLogoPath: string  = `${environment.hRef}assets/Milele_logo_white.png`;
  logoPath: string  = `${environment.hRef}assets/logo_w.png`;
  warnPath: string = `${environment.hRef}assets/warn.png`;

  disclaimer: string = 'Please note that we will be saving your information as you proceed along the steps';
  powerdByText: string = 'Powered by ICEA LION Group. All rights reserved.';

  isPrivateTrust: boolean = true;

  iSwear = new FormControl(false);
  estateDataHolder: any = null;
  resumeActiveTextEstate: string = '';
  showContinuePopup: boolean = false;

  otpForm = this.formBuilder.group({
    otp: ['']
  });

  constructor(
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly notificationService: NotificationService,
    private readonly estateControlService: EstateControlService
  ) {
    this.estateControlService.planType = 0;
  }

  
  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe(async (params) => {
      try {
        if (params["session"] == undefined) {
          await this.initLocal();
        } else {
          this.session = params["session"];
          this.estateControlService.session = this.session;
          await this.initResume(this.session);
        }
        
      } catch (error) {
        console.error('Estate Planning Resume! ', error);
      }

      if (this.estateControlService.planType === 0) this.estateControlService.showChecklist = true;
      else this.estateControlService.showChecklist = false;
    });
  }

  resume: boolean = false;
  otpReady: boolean = false;
  otpValue: number = 0;
  otpLoading: boolean = false;
  otpEmail:string = 'that was used to set up the trust';

  get onlineStorageObject(): any {
    return this.estateControlService.onlineStorageObject;
  }
  get showResumePopup(): boolean {
    return this.estateControlService.showResumePopup;
  };

  get loading(): boolean {
    return this.notificationService.loading;
  };
  get loadingTab(): boolean {
    return this.notificationService.loadingTab;
  };
  get activeTab(): number {
    return this.estateControlService.activeTab;
  }
  get planType(): number {
    return this.estateControlService.planType;
  }

  // Type guard function to check if an object matches the SessionData type
  isSessionData(obj: any): obj is SessionData {
    return (
      typeof obj === 'object' &&
      obj !== null &&
      typeof obj.SessionId === 'string'
    );
  }

  async initLocal(onlineData: any = null): Promise<void> {
    const key = await this.estateControlService.getData(this.estateControlService.estateTypeKey);
    let data = await this.estateControlService.getData(key);
    if (onlineData) data = onlineData;

    if (data?.timeStamp) {
      if (!environment.production) console.log('Data ', data);

      const timeDiff = Date.now() - Number.parseInt(data.timeStamp);
      this.estateDataHolder = data;
      console.log('Time Diff ', this.estateDataHolder);
      
      if (data.activeTab === 1) {
        this.resumeActiveTextEstate = 'Settlor Information';
        if (data.planType === 1) this.resumeActiveTextEstate = 'Testator';
      }
      if (data.activeTab === 2) this.resumeActiveTextEstate = 'Payment';

      if (data.activeTab === 3) {
        this.resumeActiveTextEstate = 'Beneficiaries';
        if (data.planType === 1) this.resumeActiveTextEstate = 'Will Executor';
      }
      if (data.activeTab === 4) this.resumeActiveTextEstate = 'Assets';

      if (data.activeTab === 5) {
        this.resumeActiveTextEstate = 'Trustees';
        if (data.planType === 1) this.resumeActiveTextEstate = 'Beneficiaries';
      }
      if (data.activeTab === 6) {
        this.resumeActiveTextEstate = 'Enforcer';
        if (data.planType === 1) this.resumeActiveTextEstate = 'Witness';
      }

      if (data.activeTab === 7) this.resumeActiveTextEstate = 'Preview';
      

      if (this.estateDataHolder.TrustID) {
        if (!environment.production) console.log('timestamp ', this.estateDataHolder);

        if (timeDiff < 86400000 ) {
          this.showContinuePopup = true;
        } else {
          if (environment.production) await this.estateControlService.clearServiceRecords();
          else this.showContinuePopup = true;
        }
      }
    }
  }
  async initResume(session: string): Promise<void> {
    const sessionData = decodeSessionData(session);
    if (this.isSessionData(sessionData) && sessionData.SessionId && sessionData.SessionId !== '') {
      await this.estateControlService.checkProgress(session);
      if (this.onlineStorageObject) {
        if (this.onlineStorageObject.planType == 0) {
          this.otpEmail = hideEmailAddress(this.onlineStorageObject.settlors[0].Email);
          this.estateControlService.showChecklist = true;
          
        } else {
          this.otpEmail = hideEmailAddress(this.onlineStorageObject.testators[0].Email);
          this.estateControlService.showChecklist = false;
        }
      }
    } else {
      this.initLocal();
    }
  }

  onOptionChange(value: boolean): void {
    this.isPrivateTrust = value;

    if (this.isPrivateTrust) {
      this.estateControlService.planType = 0;
      this.estateControlService.showChecklist = true;
      this.estateControlService.updateRecord(0);        
    } else {
      this.estateControlService.planType = 1;
      this.estateControlService.showChecklist = false;
      this.estateControlService.updateRecordWill(0);
    }
  }

  onOtpChange(otp: string) {
    if (otp.length === 6) {
      this.otpReady = true;
      this.otpValue = Number.parseInt(otp);
    } else {
      this.otpReady = false;
    }
  }

  async verifyOTP(): Promise<void> {
    if (!this.otpLoading) {
      try {
        this.otpForm.disable();
        if (this.otpValue === this.onlineStorageObject.OTP) {
          // update data
          await this.estateControlService.updateDataFromStorage(this.onlineStorageObject);
          if (this.onlineStorageObject.TrustID) {
            this.navEstate();
          }
          this.notificationService.viewToast('info', 'Session resumed');
        } else {
          this.notificationService.viewToast('error', 'Invalid OTP provided');
        }
      } catch (error) {
        console.error('Verify OTP! ', error);
        this.notificationService.viewToast('error', 'An error occurred');
      }
      this.closeOTPPopup();
    }
  }

  closeOTPPopup(): void {
    if (!this.otpLoading) {
      this.estateControlService.showResumePopup = false;
    }
  }

  navHome(): void {
    const nextPage = ``;
    if (this.session == '') {this.router.navigate([nextPage]);}
    else {this.router.navigate([nextPage], {queryParams: {session: this.session}});}
  }

  async resumeEstate(resume: boolean = true): Promise<void> {
    this.resume = resume;
    if (resume) {
      await this.estateControlService.updateDataFromStorage();
    
      if (this.estateControlService.TrustID) {
        if (this.estateControlService.planType === 0) this.estateControlService.showChecklist = true;
        else this.estateControlService.showChecklist = false;
      }
      this.navEstate();
    } else {
      this.estateControlService.resetLocalData();
    }
    this.showContinuePopup = false;
  }

  async navEstate(): Promise<void> {
    let naxPage = `/estate-planning/region`;
    if (this.resume) {
      naxPage = `/estate-planning/set-up`;
    }
    
    if (this.session) this.router.navigate([naxPage], {queryParams: {session: this.session}});
    else this.router.navigate([naxPage]);
  }
}
